import { ResumePetisSimulationProposalClientResponse } from '../../@types/ResumePetisSimulationProposal'
import {
  GetDigitalSignatureSettingsClientResponse,
  SignatureSettings,
} from '../../@types/digitalSignature/getDigitalSignatureSettings'
import { SendDigitalSignatureRequestClientResponse } from '../../@types/digitalSignature/sendDigitalSignature'
import { EMAIL_OPTION_CODE } from '../../Components/Confirmation/Expanded'
import { useDigitalSignatureSettingsStore } from '../../Stores/digitalSignature/useDigitalSignatureSettingsStore'
import { useSendDigitalSignatureStore } from '../../Stores/useSendDigitalSignatureStore'

const SEND_DIGITAL_SIGNATURE_STATUS_ACTIVE = 'Active'

export const useSendDigitalSignatureHydration = () => {
  const { setSendDigitalSignature } = useSendDigitalSignatureStore()
  const {
    setIsSendSignature,
    setSignatureTypeSelected,
    setOPTData,
    setIsInitialSignatureClicked,
  } = useDigitalSignatureSettingsStore()

  const handleCurrentSettingsSelected = (
    data: ResumePetisSimulationProposalClientResponse | null,
    settings: GetDigitalSignatureSettingsClientResponse,
  ) => {
    const digitalSignature = data?.processData?.digitalSignature

    const currentSettings = settings?.signatureSettings?.find(
      (item) =>
        item?.signatureType ===
        digitalSignature?.participantList?.[0]?.signatureType,
    ) as SignatureSettings

    setSignatureTypeSelected(currentSettings)

    if (
      digitalSignature?.participantList?.[0]?.signatureType ===
      EMAIL_OPTION_CODE
    ) {
      setIsInitialSignatureClicked(true)
    }
  }

  const handleSendDigitalSignatureHydration = (
    data: ResumePetisSimulationProposalClientResponse,
  ) => {
    const digitalSignature = data.processData?.digitalSignature

    setOPTData({
      email: digitalSignature?.participantList?.[0]?.email || '',
      phone: digitalSignature?.participantList?.[0]?.phoneNumber || '',
    })

    setIsSendSignature(
      digitalSignature?.status === SEND_DIGITAL_SIGNATURE_STATUS_ACTIVE,
    )

    const sendDigitalSignature: SendDigitalSignatureRequestClientResponse = {
      digitalSignature: {
        signatureId: digitalSignature?.id,
        participants: {
          deviceUrl: digitalSignature?.participantList?.[0]?.deviceList?.map(
            (participant) => ({
              device: participant.name,
              url: participant.url,
            }),
          ),
        },
      },
    }

    setSendDigitalSignature(sendDigitalSignature)
  }

  return {
    handleSendDigitalSignatureHydration,
    handleCurrentSettingsSelected,
  }
}
